import { EmbeddedMod } from "@src/store/slices/experienceBuilder/types";
import { getModHandler } from "@src/store/slices/experienceBuilder/common/utils/modHandlerRegistry";

export const getModErrors = (mod: EmbeddedMod): Record<string, string> =>
  getModHandler(mod).getErrors(mod);
